import classNames from 'classnames';

import React, {
  forwardRef,
  ForwardRefExoticComponent,
  HTMLAttributes,
  ReactElement,
  RefAttributes,
  useEffect,
} from 'react';

import { ItemsDisplayMode } from './config';
import { TabbarContextProvider } from './context';
import styles from './tab-bar2.scss';
import { ItemsDisplayModeEnumType } from './types';

type Props = RefAttributes<HTMLDivElement> &
  HTMLAttributes<HTMLDivElement> & {
    children: React.ReactElement[];
    itemsDisplayMode?: ItemsDisplayModeEnumType;
    dataTestId?: string;
  };

const COMPONENT_ID = 'modulor-tab-bar2';

/**
 * @deprecated TabBar2 is deprecated.
 * The component was entirely moved to widgets-platform to facilitate ui updates and encapsulation.
 *
 * This component was used to display a responsive tabbar.
 */

export const TabBar2: ForwardRefExoticComponent<Props> = forwardRef<HTMLDivElement, Props>(
  (
    { children, className, itemsDisplayMode = ItemsDisplayMode.IconsTitles, ...rest },
    ref,
    dataTestId = COMPONENT_ID,
  ) => {
    useEffect(() => {
      console.warn('Modulor: TabBar2 component is deprecated');
    });
    return (
      <TabbarContextProvider itemsDisplayMode={itemsDisplayMode}>
        <div
          data-testid={dataTestId}
          data-id={dataTestId}
          data-component-name={COMPONENT_ID}
          ref={ref}
          className={classNames(className, styles.layout)}
          {...rest}>
          {React.Children.map(children, (child: ReactElement) =>
            React.cloneElement(child, {
              style: {
                width: '100%',
                maxWidth: `${100 / children.length}%`,
              },
            }),
          )}
        </div>
      </TabbarContextProvider>
    );
  },
);

TabBar2.displayName = 'TabBar2';
